// success messages
export const MEASURE_CREATED = 'Measure saved';
